import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

// images
import greyX from '../../../images/grey-x.svg';

// components
import Notifications from '../../Notifications';

// services
import AuthService from '../../../services/AuthService';
import DealerService from '../../../services/DealerService';

function AddDealerGroupModal({ isOpen, toggleMenu }) {
    const navigate = useNavigate();

    const [name, setName] = useState('')

    useEffect(() => {
        setName('')
    }, [isOpen])

    const handleSaveClick = () => {
        let validated = true;

        if (name === "") {
            Notifications("error", "Group name is required.")
            validated = false;
        }

        if (validated) {
            const newDealerGroup = {
                name: name
            }

            DealerService.createDealerGroup(
                newDealerGroup
            ).then(response => {
                Notifications('success', 'Dealer group has been created.')
                console.log(response)
                toggleMenu(response.data)
            }).catch(err => {
                if (err.statusCode === 401 && err.message === 'Token is expired, please update your token.') {
                    AuthService.logout()
                    navigate('/login')
                }
                Notifications("error", err['message'])
            })
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => toggleMenu()}
            ariaHideApp={false}
            closeTimeoutMS={200}
            className='modal-territory'
        >   
            <div className='modal-body'>
                <div className='modal-header'>
                    <h2><b>Add Dealer Group</b></h2>
                    <button className='close' onClick={() => toggleMenu()}>
                        <img src={greyX} alt="Close"/>
                    </button>
                </div>
                <div className="details">
                    <div>
                        <span>
                            Group Name
                        </span>
                        <input 
                            type='text'
                            placeholder='Name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className='input input__form'
                        />
                    </div>

                </div>
            </div>
            <div className="modal-footer">
                <button
                    className='link__form-add'
                    onClick={handleSaveClick}
                >
                    Save
                </button>
            </div>
        </Modal>
    );
};

export default AddDealerGroupModal;